<template>
  <v-row justify="center">
    <v-dialog v-model="open" width="632px" :fullscreen="isMobileBreakpoint">
      <v-card dense>
        <v-toolbar class="pa-7" elevation="0">
          <v-toolbar-title
            class="body-regular-medium font-weight-medium"
            :class="{
              'neutral-20-dark--text': !$vuetify.theme.dark,
            }"
            style="line-height: 120%"
          >
            {{
              selectedKeys.every((key) => key.status_key === true)
                ? $t('message.pages.drm.activateKey.title')
                : $t('message.pages.drm.disabledKey.title')
            }}
            <p
              class="body-regular-smaller neutral-40-light--text mb-0"
              style="white-space: normal"
            >
              {{ selectedKeys.length }}
              {{
                selectedKeys.length > 1
                  ? $t('message.pages.drm.modalRemoveKey.keysSelected')
                  : $t('message.pages.drm.modalRemoveKey.keySelected')
              }}
            </p>
          </v-toolbar-title>
          <v-icon
            @click="handleCloseDrmToggleStatus"
            class="close-icon ml-auto"
            size="24"
            color="grey"
            style="cursor: pointer"
          >
            mdi-close
          </v-icon>
        </v-toolbar>
        <v-card-text class="px-7 pb-0">
          <v-row no-gutters>
            <v-col cols="12">
              <span class="body-regular-small neutral-40-light--text">
                {{
                  selectedKeys.every((key) => key.status_key === true)
                    ? $t('message.pages.drm.activateKey.description', {
                        key: selectedKeys.length,
                      })
                    : $t('message.pages.drm.disabledKey.description', {
                        key: selectedKeys.length,
                      })
                }}
              </span>
            </v-col>
            <v-col
              v-if="selectedKeys.every((key) => key.status_key !== true)"
              class="my-4"
            >
              <span class="body-regular-small neutral-40-light--text">{{
                $t('message.pages.drm.disabledKey.posibleEnable')
              }}</span>
            </v-col>
            <v-col cols="12" class="mb-2">
              <v-checkbox
                v-model="permanentConfirm"
                :disabled="isFetching"
                dense
              >
                <template v-slot:label>
                  <span class="mt-1" style="font-size: 14px">
                    {{ $t('message.pages.drm.disabledKey.confirmCheckbox') }}
                  </span>
                </template>
              </v-checkbox>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions
          class="pa-7 card-actions"
          :class="{ 'mobile-actions': isMobileBreakpoint }"
        >
          <a
            type="primary"
            size="small"
            target="_blank"
            :href="$t('message.pages.drm.drmWatermark.howToUseHref')"
            >{{ $t('message.pages.drm.modalRemoveKey.infoAboutDrm') }}
            <v-icon class="brand-60-base--text" size="12"
              >mdi-open-in-new</v-icon
            ></a
          >
          <v-spacer v-if="!isMobileBreakpoint"></v-spacer>
          <base-btn
            type="tertiary"
            class="mr-3"
            text
            @click="handleCloseDrmToggleStatus"
            :disabled="isFetching"
          >
            {{ $t('message.cancel') }}
          </base-btn>
          <base-btn
            :disabled="!canConfirm || isFetching"
            :loading="isFetching"
            @click="handleEdit"
          >
            <span>{{
              selectedKeys.every((key) => key.status_key === true)
                ? $t('message.pages.drm.activateKey.enabled')
                : $t('message.pages.drm.disabledKey.disabled')
            }}</span>
          </base-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-row>
</template>

<script>
import drmApi from '@/services/drmApi'
import { mapActions, mapMutations, mapState } from 'vuex'

export default {
  name: 'DrmDeleteKey',
  components: {},
  data: () => ({
    open: false,
    isFetching: false,
    countVideos: 0,
    selectedKeys: [],
    selectedGroup: {
      name: '',
      id: '',
    },
    removeText: '',
    password: '',
    showPassword: false,
    permanentConfirm: false,
    passwordError: false,
    passwordErrorMessage: '',
    apiError: null,
  }),
  computed: {
    ...mapState('user', {
      isMobileBreakpoint: 'isMobileBreakpoint',
      isTabletBreakpoint: 'isTabletBreakpoint',
    }),
    isMultiple() {
      return !!this.selectedKeys?.length
    },
    canConfirm() {
      return this.permanentConfirm
    },
    passwordErrorMessages() {
      return this.passwordError
        ? [this.$t('message.pages.drm.modal.removeGroup.inputPasswordInvalid')]
        : []
    },
  },
  mounted() {
    this.$root.$on('drmToggleStatusKey', ({ group, keys }) => {
      this.resetState()
      this.selectedGroup = group
      console.log(group)
      this.selectedKeys = keys
      this.hideCrispButton()
      this.open = true
    })
  },
  beforeDestroy() {
    this.$root.$off('drmRemoveGroupModal')
    this.selectedKeys = []
    this.showCrispButton()
  },
  methods: {
    ...mapActions('session', ['signInUser']),
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    resetState() {
      this.passwordError = false
      this.passwordErrorMessage = ''
      this.showCrispButton()
    },
    async validatePassword() {
      this.passwordError = false
      this.passwordErrorMessage = ''
      try {
        await this.signInUser({
          username: this.$store.getters['session/userAttributes'].email,
          password: this.password,
        })
        return true
      } catch (error) {
        this.passwordError = true
        this.passwordErrorMessage = this.$t(
          'message.pages.drm.modal.removeGroup.inputPasswordInvalid'
        )
        return false
      }
    },
    async handleEdit() {
      this.updateError = false
      this.isFetching = true

      console.log(this.selectedKeys)
      try {
        const promises = this.selectedKeys.map((key) =>
          drmApi.drmUpdatePrivateToken(key.id, {
            drm_group_id: key.drm_group_id,
            string1: key.string1,
            string2: key.string2,
            string3: key.string3,
            status_key: key.status_key,
          })
        )

        await Promise.all(promises)
        let text = this.$t('message.pages.drm.drmListKeys.disableKey')
        if (this.selectedKeys[0].status_key) {
          text = this.$t('message.pages.drm.drmListKeys.activateKey')
        }
        if (this.selectedKeys.length > 1) {
          text = this.$t('message.pages.drm.drmListKeys.disableKeys')
          if (this.selectedKeys[0].status_key) {
            text = this.$t('message.pages.drm.drmListKeys.activateKeys')
          }
        }
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          type: 'success',
          text: text,
        })
        this.$root.$emit('reloadTokens')
        this.handleClose()
      } catch (e) {
        this.updateError = true
        if (e.response?.status) this.errCode = e.response.status
        if (e.response?.data?.errMsg) this.errMsg = e.response.data.errMsg
      }

      this.isFetching = false
    },
    handleCloseDrmToggleStatus() {
      this.open = false
      this.removeText = ''
      this.password = ''
      this.permanentConfirm = false
      this.showPassword = false
      this.showCrispButton()
    },
    hideCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton && this.isMobileBreakpoint) {
        crispButton.style.setProperty('display', 'none', 'important')
      }
    },
    showCrispButton() {
      const crispButton = document.querySelector('.crisp-client')
      if (crispButton) {
        crispButton.style.removeProperty('display')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
::v-deep .v-toolbar {
  height: 90px !important;
}

::v-deep .v-toolbar__content {
  padding: 0 !important;
  align-items: flex-start !important;
}

.input::v-deep {
  label {
    left: -10px !important;
  }

  input::placeholder {
    font-size: 12px !important;
  }
}

.card-actions {
  border-top: 1px solid var(--v-neutral-95-lightest-base) !important;
}

.mobile-actions {
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;

  .base-button {
    width: 50%;
  }
}
</style>
